var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Group } from "@visx/group";
import { scaleBand, scaleLinear } from "@visx/scale";
import { Bar } from "@visx/shape";
import { ScaleSVG } from "@visx/responsive";
import { Fragment, useMemo } from "react";
import { AxisBottom } from "@visx/axis";
import { intervalToDuration } from "date-fns";
var verticalMargin = 0;
// accessors
var getTimestamp = function (d) { return d.timestamp; };
var getAmplitude = function (d) { return Number(d.amplitude); };
var axisStrokeColor = "var(--brand-primary)";
var formatDuration = function (end) {
    var duration = intervalToDuration({ start: 0, end: end });
    // @ts-expect-error
    var zeroPad = function (num) { return String(num).padStart(2, "0"); };
    var formatted = [
        // duration.hours,
        duration.minutes,
        duration.seconds,
    ]
        // .filter(Boolean)
        .map(zeroPad)
        .join(":");
    return formatted;
};
var WaveFormAudio = function (_a) {
    var width = _a.width, height = _a.height, _b = _a.events, events = _b === void 0 ? false : _b, _c = _a.data, data = _c === void 0 ? [] : _c, children = _a.children, _d = _a.showAxis, showAxis = _d === void 0 ? false : _d, uniqueName = _a.uniqueName;
    // bounds
    var xMax = width;
    var yMax = height / 2;
    // scales, memoize for performance
    var xScale = useMemo(function () {
        return scaleBand({
            range: [0, xMax],
            round: false,
            domain: data.map(getTimestamp),
            padding: 0.4,
        });
    }, [xMax, data]);
    var yScale = useMemo(function () {
        return scaleLinear({
            range: [yMax, 0],
            round: true,
            domain: [0, Math.max.apply(Math, data.map(getAmplitude))],
        });
    }, [yMax, data]);
    // scales
    var axisScale = scaleLinear({
        range: [0, width],
        domain: [
            0,
            Math.max.apply(Math, data.map(getTimestamp).map(function (timestamp) { return Math.floor(timestamp); })),
        ],
        nice: false,
    });
    return width < 10 ? null : (_jsxs(ScaleSVG, __assign({ width: width, height: height }, { children: [_jsx(Group, __assign({ top: verticalMargin / 2 }, { children: _jsxs(_Fragment, { children: [data.map(function (d) {
                            var _a;
                            var timestamp = getTimestamp(d);
                            var barWidth = xScale.bandwidth();
                            var barHeight = yMax - ((_a = yScale(getAmplitude(d))) !== null && _a !== void 0 ? _a : 0);
                            var barX = xScale(timestamp);
                            var barY = yMax - barHeight + barHeight * 0.4;
                            return (_jsx(Fragment, { children: _jsx(Bar, { x: Number.isNaN(barX) ? 0 : barX, y: barY, rx: 1, ry: 1, width: barWidth, height: barHeight * 0.6 * 2, fill: "currentColor" }, "bar-".concat(uniqueName, "-").concat(timestamp)) }, "bar-".concat(uniqueName, "-").concat(timestamp, "-fragment")));
                        }), children] }) })), showAxis && (_jsx(AxisBottom, { top: height - 20, scale: axisScale, stroke: axisStrokeColor, 
                // @ts-expect-error
                tickFormat: formatDuration, tickStroke: axisStrokeColor, tickLabelProps: function () { return ({
                    fill: axisStrokeColor,
                    fontSize: 11,
                    textAnchor: "middle",
                }); } }))] })));
};
// TODO: export formatDuration somewhere more global
export { WaveFormAudio, formatDuration };
//# sourceMappingURL=WaveFormAudio.js.map